import { type ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './StatusBadge.module.css';

export type Status =
  | 'fresh'
  | 'stale'
  | 'partial'
  | 'unavailable'
  | 'contradicted'
  | 'positive'
  | 'warning'
  | 'negative'
  | 'info';

export function StatusBadge({
  status,
  children,
  className,
}: {
  status: Status;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={clsx(styles.root, styles[status], className)} role="status">
      <span className={styles.mark} aria-hidden="true" />
      {children}
    </span>
  );
}
